export default __webpack_public_path__ + "static/media/confirmIllustration.516399fe.svg";